import { FC } from 'react';

import CommunicationDataSection from './CommunicationDataSection';
import CommunicationAttachmentsSection from './CommunicationAttachementsSection';
import CommunicationRecipientsSection from './CommunicationRecipientsSection';

const CommunicationBody: FC = () => (
  <>
    <CommunicationDataSection />

    <CommunicationRecipientsSection />

    <CommunicationAttachmentsSection />
  </>
);

export default CommunicationBody;
